// extracted by mini-css-extract-plugin
export default {"headerForm":"CreateConsentForm_headerForm__vjGDh","submitButton":"CreateConsentForm_submitButton__xgYxb","banner":"CreateConsentForm_banner__1xwcL"};